import React, { Component } from 'react'
import { HashRouter, Switch, Redirect, Route } from 'react-router-dom'
import loadable from './loadable'
import MyNav from './components/myNav2'
import styleObj from './App.module.scss'
import { getData } from './assets/js/getData'

const Chongqing = loadable(() => import('./pages/chongqing'))
const Hangzhou = loadable(() => import('./pages/hangzhou'))
const Shanghai = loadable(() => import('./pages/shanghai'))
const Xian = loadable(() => import('./pages/xian'))

class App extends Component {
  constructor() {
    super()
    this.state = {
      init: false,
    }
  }
  render() {
    let minH = window.innerHeight
    let { init } = this.state
    return (
      <div className={styleObj['App']} style={{ minHeight: `${minH}px` }}>
        {!!init && (
          <HashRouter>
            <MyNav />
            <div className={styleObj['main']}>
              <Switch>
                <Route exact path="/" component={Chongqing}></Route>
                <Route exact path="/chongqing" component={Chongqing}></Route>
                <Route exact path="/hangzhou" component={Hangzhou}></Route>
                <Route exact path="/shanghai" component={Shanghai}></Route>
                <Route exact path="/xian" component={Xian}></Route>
                <Redirect to="/" />
              </Switch>
            </div>
          </HashRouter>
        )}
      </div>
    )
  }
  componentDidMount() {
    getData().then((message) => {
      this.setState({
        init: true,
      })
    })
  }
}

export default App
